import React from 'react';
import { Accordion } from 'components/molecules/Accordion';
import { NotificationsEntry } from 'components/atoms/Notifications/NotificationsEntry';
import { useMutation } from '@apollo/client';
import { UPDATE_OPTIONS } from '../../../graphql/mutation/options/updateOptions';
import {
  UpdateUserOptionsMutation,
  UpdateUserOptionsMutationVariables
} from '../../../graphql/generated/graphql';
import { useDispatch, useSelector } from 'react-redux';
import { setUserNotifications } from '../../../store/actions/user.actions';
import { getNotificationsReadIds } from '../../../store/selectors/user/user.selectors';
import { Notification } from '../../../types/notifications/notification.def';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';

interface AccordionNotificationsProps {
  notifications: Notification[];
}
const AccordionNotifications = ({
  notifications
}: AccordionNotificationsProps) => {
  const notificationsIds = useSelector(getNotificationsReadIds);

  const dispatch = useDispatch();
  const [updateNotificationsRead] = useMutation<
    UpdateUserOptionsMutation,
    UpdateUserOptionsMutationVariables
  >(UPDATE_OPTIONS, {
    onCompleted: res =>
      dispatch(setUserNotifications(res.updateOptions.options.notifications)),
    onError: err => console.error(err)
  });
  const markAsRead = notifId => {
    !notificationsIds.includes(notifId) &&
      updateNotificationsRead({
        variables: {
          key: 'notifications',
          data: notifId
        }
      });
  };
  return (
    <>
      {notifications.length > 0 ? (
        notifications.map(message => (
          <Accordion
            key={message.id}
            onClick={() => markAsRead(message.id)}
            icon={
              !notificationsIds.includes(message.id) && <FlatIcon icon="Bell" />
            }
            innerContent={true}
            title={message.title}
          >
            <NotificationsEntry
              contentText={message.description}
              link={message.link}
            />
          </Accordion>
        ))
      ) : (
        <NotificationsEntry contentText="Aucune nouvelle notification. 🏜️" />
      )}
    </>
  );
};

export default AccordionNotifications;
